import { login, logout, getInfo } from '@/api/login' // eslint-disable-line
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    dept: '',
    deptcode: '',
    userCode: '',
    idCard: '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_DEPT: (state, dept) => {
      state.dept = dept
    },
    SET_CODE: (state, deptcode) => {
      state.deptcode = deptcode
    },
    SET_USERCODE: (state, userCode) => {
      state.userCode = userCode
    },
    SET_IDCARD: (state, idCard) => {
      state.idCard = idCard
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          if (res.status == '200') {
            setToken(res.data.token)
            commit('SET_TOKEN', res.data.token)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, dispatch },payload) {
      console.log(payload,'dispatch')
      dispatch('exam/initExamOptions')
      return new Promise((resolve, reject) => {
        // 用户信息
        // getInfo().then((res) => {
          if(!payload){
            reject()
          }else{
          let user = payload
          commit('SET_NAME', user.userName)
          commit('SET_IDCARD', user.idCard)
          commit('SET_USERCODE', user.id)
          commit('SET_DEPT', user.deptName)
          commit('SET_CODE', user.deptCode)
          resolve(user)
          }
        // }).catch(error => {
        //   reject(error)
        // })
      })
    },
    // 退出系统
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then((res) => {
          commit('SET_TOKEN', '')
          commit('SET_NAME', '')
          commit('SET_USERCODE', '')
          removeToken()
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_NAME', '')
        commit('SET_USERCODE', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user